/** @jsxImportSource theme-ui */
import { useField } from 'formik';
import React from 'react';
import { Dropdown, DropdownItemProps } from 'semantic-ui-react';

import { SemanticFormikProps } from './FormikSemanticProps';

type FormikSemanticMultiselectProps = SemanticFormikProps & {
  options?: DropdownItemProps[];
  loading?: boolean;
};

export const FormikSemanticMultiselect: React.FC<FormikSemanticMultiselectProps> = ({
  name,
  placeholder,
  error,
  options,
  loading,
}) => {
  const [field, , helpers] = useField(name);
  const { setValue, setTouched } = helpers;
  const { value } = field;

  return (
    <Dropdown
      clearable
      fluid
      multiple
      search
      selection
      options={options}
      placeholder={placeholder}
      value={value}
      loading={loading}
      onChange={(_, { value }) => setValue(value)}
      onBlur={(_, { value }) => setTouched(true)}
    />
  );
};
